import React, { useState, useEffect } from "react";
import { webTitle } from "@/config/config";
import HomeLogo from "@/assets/loginLogo.svg";
import UserPanel from "@/Components/PageTop/UserPanel";
import { Space, Radio, Result, Popconfirm } from "antd";
import PageTitle from "@/Components/PageTop/PageTitle";
import { useNavigate } from "react-router-dom";
import PageTop from './PageTop'

const Component = (props: any) => {
  const [showType, setShowType] = useState<string>("img");
  const [count, setCount] = useState<number[]>([11, 22, 33, 44]);
  const [source, setSource] = useState<number[]>([11, 22, 33, 44]);
  const history = useNavigate();

  return (
    <>
    <PageTop/>
      <div className="indexShow" style={{ height: "calc(100vh - 60px)" }}>
        <div
          className="loadingArea t3"
          style={{ marginBottom: "30rem" }}
        >
          <Result title="正在开发中......" />
        </div>
      </div>
    </>
  );
};

export default Component;
